import { anySegmentReady } from './host-contract.mjs';
import MathRods from './MathRods.js';
import MathRodsOptions from './MathRodsOptions';
import { validateSegment } from './model.mjs';
import { createGameData } from './createGameData.mjs';
export default {
  Template: MathRods,
  Options: MathRodsOptions,
  createGameData,
  validateActivity: data => anySegmentReady(data, validateSegment),
  optionsArray: ['delayBeforeNext', 'showAnswer', 'showGrid', 'writingActivity'],
};
